export default {"src":"/_next/static/media/no-image.7ecc376a.svg","height":301,"width":312};